import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import Dropzone from 'react-dropzone';

class RosterWidget extends React.Component {
  render() {
    const spinner = (
      <div className="text-center">
        <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
        <span className="sr-only">Loading...</span>
      </div>
    );
    let roster;
    if (this.props.tour.groups.length > 0) {
      roster = (<div>
        {/* <p>{this.props.tour.members.length} Members.</p> */}
        <p>{this.props.tour.groups.length} Groups.</p>
      </div>);
    } else {
      let text;
      if (this.props.IsProcessing) {
        text = spinner;
      } else {
        text = (
          <div className="text-center">
            Drop your roster spreadsheet here, or click to select files to upload.
            <br /><i className="fa fa-file-excel-o fa-5x" aria-hidden="true" />
          </div>);
      }
      roster = (
        <div>
          <Dropzone
            className="overview-tab-panel-dropzone"
            ref={(node) => { this.dropzone = node; }}
            onDrop={this.props.onDrop}
          >
            <div>{text}</div>
          </Dropzone>
          <Link to="/Example_Tour-Roster.xlsx" target="_blank">Download Template</Link>
        </div>
        );
    }
    return (
      <div className="col-sm-3">
        <Panel header="Participants">
          { roster }
        </Panel>
      </div>
    );
  }
}
export default RosterWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/RosterWidget.js